module.exports = __webpack_public_path__ + "static/machine05-sq-f150b9341628f25e08f50dbe93bdd6aa.png";